// extracted by mini-css-extract-plugin
module.exports = {"allowOverflow":"UnidentifiedTraffic_allowOverflow__A9LUp"};